
/* styles */
require("!!vue-loader/node_modules/vue-style-loader!css-loader?minimize!../../node_modules/.10.3.0@vue-loader/lib/style-rewriter?id=data-v-4ba04ce0&scoped=true!less-loader!../../node_modules/.10.3.0@vue-loader/lib/selector?type=styles&index=0!./data.vue")

var Component = require("!../../node_modules/.10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/.10.3.0@vue-loader/lib/selector?type=script&index=0!./data.vue"),
  /* template */
  require("!!../../node_modules/.10.3.0@vue-loader/lib/template-compiler?id=data-v-4ba04ce0!../../node_modules/.10.3.0@vue-loader/lib/selector?type=template&index=0!./data.vue"),
  /* scopeId */
  "data-v-4ba04ce0",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/data.vue
// module id = 88
// module chunks = 1